import React from "react";
import OperationError from "components/comp/OperationError";
import OperationSR from "components/comp/OperationSR";
import SubPicture from "components/comp/SubPicture";
import laptopImg from "assets/images/laptop.jpg"
// why: 서비스 처리 프로세스를 시각적으로/서술적으로 설명하는 전용 페이지

const CompProcess = () => {
  return (
    <main className="page-sub">
      <section className="company-main">
        <SubPicture img={laptopImg}/>
        <OperationSR/>
        <OperationError/>
      </section>
    </main>
  );
};

export default CompProcess;


